import React, {memo,useEffect, useRef, useState} from "react";
import Styles from './BarChart/BarChart.module.scss'
import {BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer} from 'recharts';
import {Legend} from "chart.js";
import {showDuration} from "../../../../util/util";



const BarChartContainer = props => {
    const [openXAxis, setOpenXAxis] = useState(false)
    const [openYAxis, setOpenYAxis] = useState(false)
    const [yAxisLabels, setYAxisLabels] = useState([])
    const [yAxisLabelSelect, setYAxisLabelSelect] = useState('total_duration')
    const [yAxisWidth, setYAxisWidth] = useState(5)
    const [xAxisWidth, setXAxisWidth] = useState(25)
    const [barChart, setBarChart] = useState(false)
    const [chartWrapper2Width, setChartWrapper2Width] = useState(500)
    const [data, setData] = useState([])
    const [focusBar, setFocusBar] = useState(null)
    const [barHeight, setBarHeight] = React.useState(200)
    // const [yAxisLabel , setYAxisLabel] = useState('Total Duration')

    const chartWrapper2Ref = useRef()

    useEffect(() => {
        let yAxisLabels = Object.keys(props.barChartData[props.select])
         if(props.select.toLowerCase().includes('case')){
            console.log('case',yAxisLabels)
         }else{

         }
        setYAxisLabels(yAxisLabels)
        console.log('data chart 1',props.select,yAxisLabels,yAxisLabels[0])
        initialChart(yAxisLabels[0])
    }, [props.barChartData])


    function handleResize() {
        // console.log('xAxisWidth',chartWrapper2Ref.current.clientHeight , xAxisWidth)
        // setBarHeight(chartWrapper2Ref.current.clientHeight - xAxisWidth - 30)
        setBarHeight(chartWrapper2Ref.current.clientHeight - xAxisWidth - 30)
    }
    const size = () => {
        if(chartWrapper2Ref.current)
        return chartWrapper2Ref.current.clientHeight - 75
        else
        return 200
    }
    useEffect(() => handleResize(),[xAxisWidth])
    useEffect(() => {
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })


    useEffect(()=> {
        setYAxisWidth(1)
        setXAxisWidth(1)
    },[yAxisLabelSelect,props.select])


    const formatYAxis = (value) => {
        if(yAxisLabelSelect.includes('duration')){
            value = showDuration(value)
            getWidth(value)
            return value
        }else{
            getWidth(value)
            return value
        }
        function getWidth(value){
            if(value.toString().length > yAxisWidth) {
                setYAxisWidth(value.toString().length)
            }
        }
    }
    const formatXAxis = (value) => {
        if(value.toString().length > xAxisWidth / 3) {
            setXAxisWidth(value.toString().length * 3)
        }
        return value
    }


    const handleYAxisLabelWidth = () => {
        return  yAxisLabelSelect.includes('duration') ? yAxisWidth * 7 : yAxisWidth * 12
    }
    const handleChartWidth = () => {
       let width = chartWrapper2Width + (yAxisLabelSelect.includes('duration') ? 70 : 0)
       if(width < 190) width = 190
        return width
    }
    const CustomTooltip = ({ active, payload, label }) => {
        const convertValue = value => {
            if(yAxisLabelSelect.includes('duration'))
                return showDuration(value)
            else
                return value
        }
        if (active && payload && payload.length) {
            return (
                <div className={Styles.customTooltip}>
                    <p>{label}</p>
                    <p className="pb-1">{convertValue(payload[0].value)}</p>
                </div>
            );
        }

        return null;
    };
    const renderBarChart = (
        // margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        // <ResponsiveContainer height="100%">
        <BarChart
            margin={{bottom:xAxisWidth}}
            barCategoryGap={16}
            barGap={20}
            width={handleChartWidth()}
            height={size()}
            data={data}
            // onMouseMove={state => {
            //     if (state.isTooltipActive) {
            //         setFocusBar(state.activeTooltipIndex);
            //     } else {
            //         setFocusBar(null);
            //     }
            // }}
            // onMouseLeave={() => {
            //     setFocusBar(null);
            // }}
        >
            {/*<CartesianGrid strokeDasharray="3 3" />*/}
            <XAxis fontSize={12} interval={0}  tick={<CustomizedAxisTick/>}  tickFormatter={formatXAxis} tickMargin={23} dataKey="name"/>
            <YAxis fontSize={12} width={handleYAxisLabelWidth()} tickFormatter={formatYAxis} />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <defs>
                <linearGradient
                    id="colorUv"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="100%"
                    spreadMethod="reflect"
                >
                    <stop offset="0" stopColor="#8A0FFF" />
                    <stop offset="1" stopColor="#A647FF" />
                </linearGradient>
            </defs>
            <defs>
                <linearGradient
                    id="colorPv"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="100%"
                    spreadMethod="reflect"
                >
                    <stop offset="0" stopColor="#e1e4f2" />
                    <stop offset="1" stopColor="#e4e4f0" />
                </linearGradient>
            </defs>
            {/*<Bar />*/}
            <Bar dataKey="pv" fill="url(#colorUv)" radius={[5, 5, 0, 0]} >
                {/*<LabelList fontSize={12} angle="45" dataKey="name" position="top" />*/}
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={focusBar === null ? 'url(#colorUv)' : focusBar === index ? 'url(#colorUv)' : 'url(#colorPv)'}  />
                ))}
            </Bar>
        </BarChart>
         // </ResponsiveContainer>
    );

    const handleFillBar = index => {
        if(focusBar === null)
            return 'url(#colorUv)'
        else if(focusBar === index)
            return 'url(#colorUv)'
        else return 'url(#colorPv)'
        // focusBar === index ? 'url(#colorUv)' : focusBar ? 'url(#colorUv)' : 'url(#colorUv)'
    }
    const initialChart = (label) => {
        if(barChart) barChart.destroy()
        setYAxisLabelSelect(label)
        let data = props.barChartData[props.select][label]
        setData(data)
        console.log('data chart',data,props.select,label,Object.keys(data).length)
        var newwidth = Object.keys(data).length * 55
        // if(newwidth > 50000) newwidth = 50000
        setChartWrapper2Width(newwidth)
        // if (data) {
        //     let xAxisLabel = Object.keys(data)
        //     let yAxisLabel = Object.keys(data).map(item => data[item])
        //     drawBarChart(xAxisLabel, yAxisLabel)
        // }
        let newData = []
        Object.keys(data).map(name => {
            newData.push({name,pv:data[name]})
        })
        setData(newData)

    }




    const xAxisLabel = () => {
        switch (props.select.toLowerCase()) {
            case 'activity':
                return 'Activity'
            case 'case':
                return 'Date'
            case 'caseid':
                return 'Date'
            default:
                return props.select.toLowerCase()
        }
    }

    return (
        <div className={Styles.barChart} ref={chartWrapper2Ref}>
            <header className={`${Styles.header} d-flex justify-content-between align-items-center px-3 pt-2`}>
                <div className="d-flex">
                    <div onClick={() => setOpenXAxis(!openXAxis)} className={Styles.dropDown} tabIndex={-1}
                         onBlur={() => setOpenXAxis(false)}>
                        <p className="f12 cap fw400 light-gray">X Axis</p>
                        <div className="d-flex align-items-center">
                            <p className="f12 fw600 dark-gary-2">{xAxisLabel()}</p>
                            {/*<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                            {/*    <path d="M10.6667 1.16666L6.00004 5.83333L1.33337 1.16666" stroke="#0A195C" stroke-linecap="round" stroke-linejoin="round"/>*/}
                            {/*</svg>*/}
                        </div>
                        {/*{openXAxis &&*/}
                        {/*<div className={Styles.subDropDown}>*/}
                        {/*    <p>item</p>*/}
                        {/*    <p>item</p>*/}
                        {/*    <p>item</p>*/}
                        {/*    <p>item</p>*/}
                        {/*    <p>item</p>*/}
                        {/*</div>*/}
                        {/*}*/}
                    </div>
                    <div onClick={() => setOpenYAxis(!openYAxis)} className={Styles.dropDown} tabIndex={-1}
                         onBlur={() => setOpenYAxis(false)}>
                        <p className="f12 fw400 light-gray">Y Axis</p>
                        <div className="d-flex align-items-center">
                            <p className="f12 cap fw600 dark-gary-2">{yAxisLabelSelect.replaceAll('_',' ')}</p>
                            <svg width="12" height="7" viewBox="0 0 12 7" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.6667 1.16666L6.00004 5.83333L1.33337 1.16666" stroke="#0A195C"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        {openYAxis &&
                        <div className={Styles.subDropDown}>
                            {yAxisLabels.map((item, key) => (
                                <p key={key} className="cap" onClick={() => initialChart(item)}>{item.replaceAll('_',' ')}</p>
                            ))}
                        </div>
                        }
                    </div>
                </div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1018 12.8634L10.1018 2.82925" stroke="#0A195C" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.5319 10.4237L10.1019 12.8637L7.67186 10.4237" stroke="#0A195C" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"/>
                    <path
                        d="M13.9624 6.77333H14.7399C16.4358 6.77333 17.8099 8.1475 17.8099 9.84416V13.9142C17.8099 15.6058 16.4391 16.9767 14.7474 16.9767H5.4641C3.76827 16.9767 2.39327 15.6017 2.39327 13.9058L2.39327 9.835C2.39327 8.14416 3.76494 6.77333 5.45577 6.77333L6.24077 6.77333"
                        stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </header>
            {/*<div className={Styles.chartWrapper}>*/}
            {/*    <div className={Styles.chartAreaWrapper}>*/}
            {/*        <div style={{width:chartWrapper2Width}} ref={chartWrapper2Ref}>*/}
            {/*        <canvas ref={chartRef} height="250" width="1200"></canvas>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className={Styles.chartWrapper2}>
                {/*style={{height:barHeight + xAxisWidth}}*/}
                <div  className={Styles.chartAreaWrapper}>
                    {/*<div style={{width:chartWrapper2Width}} ref={chartWrapper2Ref}>*/}
                    {renderBarChart}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    )
}
export default memo(BarChartContainer);

class CustomizedAxisTick extends React.Component {
    render() {
        const {
            x, y, stroke, payload,
        } = this.props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text x={35} y={0} fontSize={12} transform="rotate(-35)"  textAnchor="end" fill="#70789E" >{payload.value}</text>
            </g>
        );
    }
}
class CustomLabel extends React.Component{
    render() {
        const {x, y, stroke, value} = this.props;
        return (
            <g>
                <foreignObject x={0} y={0} width={100} height={100}>
                    <div>Label {value}</div>
                </foreignObject>
            </g>
        );
    }
};
